import { createAction } from 'lib/store-utils';
import { ShiftTimeRangeInputOpenedPayload, CreateShiftPayload } from './types';

export const BOX_SHIFT_TIME_RANGE_INPUT_OPENED = createAction<ShiftTimeRangeInputOpenedPayload>('Shift time range input / opened');
export const BOX_SHIFT_TIME_RANGE_INPUT_CLOSED = createAction('Shift time range input / closed');

export const BOX_SHIFT_TIME_RANGE_INPUT_CREATE_REQUEST = createAction<CreateShiftPayload>('Shift time range input / create request');
export const BOX_SHIFT_TIME_RANGE_INPUT_CREATE_FINISHED = createAction('Shift time range input / create finished');
